import { push } from 'connected-react-router'
import { signInAction, signOutAction, fetchAccountsAction } from './actions'
import { auth, db, FirebaseTimestamp } from '../firebase/index'
import validator from 'validator'

const accountRef = db.collection('accounts')
const mailRef = db.collection('mail')
const requestRef = db.collection('requests')

export const sendMail = (email, subject, text, redirect) => {
  return async (dispatch) => {
    if (email === '' || subject === '' || text === '' || redirect === '') {
      alert('必須項目が未入力です')
      return false
    }

    return mailRef
      .add({
        to: email,
        message: {
          subject,
          text,
        },
      })
      .then(() => {
        dispatch(push(redirect))
      })
      .catch((error) => {
        throw new Error(error)
      })
  }
}

export const fetchAccounts = () => {
  return async (dispatch) => {
    accountRef.get().then((snapshots) => {
      const accounts = []
      snapshots.forEach((snapshot) => {
        const account = snapshot.data()
        accounts.push(account)
        dispatch(fetchAccountsAction(accounts))
      })
    })
  }
}

export const saveRequest = (
  accountId,
  patName,
  patKana,
  patAge,
  patPhone,
  patEmail,
  selectedDate,
  biko
) => {
  return async () => {
    if (patName === '' || patPhone === '' || patEmail === '' || selectedDate === '') {
      alert('必須項目が未入力です')
      return false
    }

    if (!validator.isEmail(patEmail)) {
      alert('メールアドレスを確認してください')
      return false
    }

    const timestamp = FirebaseTimestamp.now()
    const ref = accountRef.doc()
    const data = {
      id: ref.id,
      accountId,
      patName,
      patKana,
      patAge,
      patPhone,
      patEmail,
      selectedDate,
      biko,
      updatedAt: timestamp,
    }
    requestRef
      .doc(ref.id)
      .set(data, { merge: true })
      .catch(() => {
        return false
      })

    return true
  }
}

export const saveAccount = (
  id,
  type,
  name,
  person,
  email,
  phone,
  address,
  url,
  token,
  cardTitle,
  cardBody,
  mailSubject,
  mailText,
  limit,
  list,
  buttonText,
  redirect,
  view
) => {
  return async (dispatch) => {
    if (
      (name === '' ||
        type === '' ||
        person === '' ||
        email === '' ||
        phone === '' ||
        address === '' ||
        url === '' ||
        token === '',
      cardTitle === '',
      cardBody === '',
      mailSubject === '',
      mailText === '',
      limit === '',
      buttonText === '',
      redirect === '',
      list === '')
    ) {
      alert('必須項目が未入力です')
      return false
    }

    const timestamp = FirebaseTimestamp.now()
    const data = {
      name: name,
      type: type,
      person: person,
      email: email,
      phone: phone,
      address: address,
      url: url,
      token: token,
      cardTitle: cardTitle,
      cardBody: cardBody,
      mailSubject: mailSubject,
      mailText: mailText,
      limit: limit,
      list: list.length !== 0 ? list.split(',') : [],
      buttonText: buttonText,
      redirect: redirect,
      view: view,
      updatedAt: timestamp,
    }

    if (id === '') {
      const ref = accountRef.doc()
      id = ref.id
      data.id = id
      data.createdAt = timestamp
    }

    return accountRef
      .doc(id)
      .set(data, { merge: true })
      .then(() => {
        dispatch(push('/accounts'))
      })
      .catch((error) => {
        throw new Error(error)
      })
  }
}

export const signIn = (email, password) => {
  return async (dispatch) => {
    if (email === '' || password === '') {
      alert('必須項目が未入力です')
      return false
    }

    auth.signInWithEmailAndPassword(email, password).then((result) => {
      const user = result.user
      if (user) {
        dispatch(
          signInAction({
            isSignedIn: true,
            uid: user.uid,
            email: user.email,
          })
        )
        dispatch(push('/accounts'))
      } else {
        return false
      }
    })
  }
}

export const signOut = () => {
  return async (dispatch) => {
    auth.signOut().then(() => {
      dispatch(signOutAction())
      dispatch(push('/'))
    })
  }
}

export const listenAuthState = () => {
  return async (dispatch) => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        dispatch(
          signInAction({
            isSignedIn: true,
            uid: user.uid,
            email: user.email,
          })
        )
      } else {
        dispatch(push('/'))
      }
    })
  }
}
